import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import Button from "@/components/atoms/actions/Button";
import CampaignGrid from "@/components/organisms/campaigns/CampaignGrid";

const Campaigns = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="p-2">
      <h1 className="mb-4 text-2xl font-bold">Campaigns</h1>

      <CampaignGrid />

      <Button onClick={() => navigate({ to: "/campaign/create" })} label={t("campaign.create.title")} />
    </div>
  );
};

export const Route = createFileRoute("/_authenticated/_sidebarLayout/campaigns")({
  component: Campaigns,
});
